import { useNavigate } from "react-router-dom";
import { getCurrentRole } from "../auth/permissions";

/**
 * Shown when an authenticated user navigates to a route they lack the
 * permission for. Friendly, not scary — they're logged in, just not
 * authorized for this particular area.
 */
export default function ForbiddenPage() {
  const navigate = useNavigate();
  const role = getCurrentRole();

  return (
    <div className="shell">
      <div className="card" style={{ maxWidth: 520, margin: "80px auto", textAlign: "center" }}>
        <p className="eyebrow">403 — Access Denied</p>
        <h1 style={{ fontSize: 28 }}>You don't have access to this page</h1>
        <p className="lede" style={{ margin: "8px auto 20px" }}>
          Your role{role ? ` (${role})` : ""} doesn't include permission for this area.
          If you think this is a mistake, ask a SuperAdmin to adjust your role.
        </p>
        <div className="actions" style={{ justifyContent: "center" }}>
          <button className="primary" onClick={() => navigate("/")}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}